import React from 'react';

import BG from '~/components/background';

import home from './images/home.png';

function SupportersApp() {
  return <BG width={960} height={5004} imgUrl={home} />;
}

export default SupportersApp;
